import { Text } from "../../../../common/components";
import { Icon } from "../../../../common/components/material";

import styles from './SettingsEmptyPane.module.scss';

export function SettingsEmptyPane (){

    return (
        <div className={styles['SettingsEmptyPane']}>
            <Icon ariaHidden name="lightbulb" size={48}></Icon>
            <p>
                <Text fontStyle="body-large" value="Select something first"></Text>
            </p>
        </div>
    );

}